// extracted by mini-css-extract-plugin
export default {"currentInfo":"CurrentInfo_currentInfo__zy9mB"};